import cn from "classnames"
import parse from "html-react-parser"
import { DynamicHeadline } from "../DynamicHeadline"
import Section, { parseColors } from "../Section"
import Shape from "../ui/Shape"
import styles from "./HomeHero.module.scss"

export const HomeHero = ({ data = {}, colors }) => {
  const {
    // hero_images: images,
    // hero_linked_entries: entries,
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    teaser_title: teaserTitle,
    teaser_text: teaserText,
    // content_text: contentText,
  } = data

  const { accent, secondaryAccent } = parseColors({ colors })

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      className={cn("home-hero", styles.homeWrapper)}
      colors={colors}
      containerClassName="relative"
    >
      {dynamicHeadline && (
        <div className={styles.headlineWrapper}>
          {teaserTitle && (
            <h1
              className="text-lg mb-2 md:text-3xl font-medium md:mb-8"
              style={{ color: accent.color }}
            >
              {teaserTitle}
            </h1>
          )}
          <DynamicHeadline
            className="lg:w-3/4 hero-text"
            headlineType={headlineType.value}
            headlineAppearance={headlineAppearance.value}
          >
            {dynamicHeadline}
          </DynamicHeadline>
          {teaserText && (
            <div className={cn(styles.text, "teaser lg:w-3/4")}>
              {parse(teaserText)}
            </div>
          )}
        </div>
      )}
      <div className={styles.backgroundElements}>
        <Shape
          type="disphere-d"
          fill={secondaryAccent.color}
          className={styles.shapeD}
        />
        <Shape
          type="half-circle"
          fill={secondaryAccent.color}
          className={styles.shapeHalfCircle}
        />
        <Shape
          type="circle"
          fill={accent.color}
          className={styles.shapeCircle}
        />
        <Shape type="donut" fill={accent.color} className={styles.shapeDonut} />
      </div>
    </Section>
  )
}

export default HomeHero
